import { DeploymentThreadTypes } from "@reporting/rp-types/deployment";

export const a = 1;

export const encodings = [
	'ASCII', 'CP1125', 'CP1131', 'CP1250', 'CP1251', 'CP1252', 'CP1253', 'CP1254',
	'CP1255', 'CP1256', 'CP1257', 'CP437', 'CP737', 'CP775', 'CP850', 'CP852', 'CP853',
	'CP855', 'CP857', 'CP858', 'CP860', 'CP861', 'CP862', 'CP863', 'CP865', 'CP866',
	'CP869', 'ISO-8859-1', 'ISO-8859-10', 'ISO-8859-13', 'ISO-8859-14', 'ISO-8859-15',
	'ISO-8859-16', 'ISO-8859-2', 'ISO-8859-3', 'ISO-8859-4', 'ISO-8859-5', 'ISO-8859-6',
	'ISO-8859-7', 'ISO-8859-8', 'ISO-8859-9', 'UTF-16', 'UTF-16BE', 'UTF-16LE', 'UTF-32',
	'UTF-32BE', 'UTF-32LE', 'UTF-8'
];

export const delimiters = [
	[';', ';'],
	['.', '.'],
	['|', '|'],
	['\t', 'tab'],
];

export const quotes = [
	['', 'none'],
	['"', '"'],
	['\'', '\'']
];

export const DATASET_SEPARATOR = '\x1E';

export const THREAD_TYPES = [
	{ k: DeploymentThreadTypes.Custom, v: 'Custom' },
	{ k: DeploymentThreadTypes.DbData, v: 'DB Data' },
	{ k: DeploymentThreadTypes.DbMaster, v: 'DB Master' },
	{ k: DeploymentThreadTypes.DbSuper, v: 'DB Super' },
	{ k: DeploymentThreadTypes.Scripts, v: 'Scripts' },
];
